// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bZLvo","tableRow":"styles_tableRow__R5kXl","noData":"styles_noData__qBzBC","dayName":"styles_dayName__aH865","theme":"styles_theme__hokLF"};